import React from 'react'
import styled from 'styled-components'
import { category } from '../../../config'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import { string, func, array } from 'prop-types'
import { Link } from 'react-router-dom'

const Header = styled.div`
  background: rgb(243, 245, 247);
  padding: 15px;
  font-size: 1.1em;
  font-weight: bold;
  border-radius: 5px;
`
const CategoryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.1em;
  font-weight: bold;
  color: ${props => props.$selected ? 'var(--first)' : 'var(--second)'};
  text-transform: uppercase;
  :hover {
    color: var(--first)
  }
`

const ItemsOnCategory = styled(Link)`
  color: var(--second);
  text-transform: none;
  display: block;
  margin-bottom: 7px;
  :hover {
    color: var(--first)
  }
`
const CategoryWrapper = styled.div`
  padding: 10px 0px;
  border-bottom: 1px solid rgb(243, 245, 247);
  padding-left: 12px;
  svg {
    color: gray;
  }
`

const CategoryMobile = props => {
  const currentItemsOnCategorySelected = props.items.filter(item => item.category === props.categorySelected)
  return (
    <div>
      <Header>
        CATEGORÍAS
      </Header>
      <div>
        {Object.keys(category).map(keyName => (
          <CategoryWrapper key={keyName}>
            <CategoryItem onClick={event => props.setCategory(keyName)} $selected={props.categorySelected === keyName}>
              {category[keyName]}
              {props.categorySelected === keyName ? (<ExpandLess />) : (<ExpandMore />)}
            </CategoryItem>
            {props.categorySelected === keyName && (
              <div style={{ width: '100%', marginTop: '8px' }}>
                {currentItemsOnCategorySelected.map(item => (
                  <ItemsOnCategory to={`/item/${item.id}`} key={item.id}>{item.title}</ItemsOnCategory>
                ))}
              </div>
            )}
          </CategoryWrapper>
        ))}
        <CategoryWrapper>
          <CategoryItem onClick={event => props.setCategory(null)} $selected={!props.categorySelected}>
            TODOS
            {!props.categorySelected ? (<ExpandLess />) : (<ExpandMore />)}
          </CategoryItem>
        </CategoryWrapper>
      </div>
    </div>
  )
}

CategoryMobile.propTypes = {
  categorySelected: string,
  setCategory: func,
  items: array
}

export default CategoryMobile
